import { Box, List, ListItem, SxProps, Theme, Typography } from '@mui/material';
import { GridColumns } from 'shared/types';
import { BackendFilterModel } from 'types/backend';

type FilterDisplayProps<T> = {
    filtersApplied?: BackendFilterModel;
    columnConfig: GridColumns<T>;
    sx?: SxProps<Theme> | undefined;
};

export default function FilterDisplay<T>({ filtersApplied, columnConfig, sx }: FilterDisplayProps<T>) {
    const getDisplayName = (columnField: string) =>
        columnConfig.find(({ field }) => field === columnField)?.headerName || columnField;

    return (
        <Box sx={{ maxHeight: '50vh', overflowY: 'auto', ...sx }}>
            <Typography variant='h6'>Filters Applied</Typography>
            <List>
                {filtersApplied?.items.map(({ columnField, value, operatorValue }, index) => (
                    <ListItem key={columnField + operatorValue + value}>
                        {index !== 0 && `${filtersApplied?.linkOperator} `}
                        {getDisplayName(columnField)} {operatorValue} {value}
                    </ListItem>
                ))}
            </List>
        </Box>
    );
}
